import { useQuery } from "@tanstack/react-query"

import { useClient } from "api"

import type { OnboardingInfoResponse } from "../types"

const useOnboardingInfo = (practiceIdentifier: string, personIdentifier?: string) => {
  const { read } = useClient()

  return useQuery({
    queryKey: ["onboarding-info", practiceIdentifier, personIdentifier],
    enabled: !!personIdentifier,
    queryFn: async (): Promise<OnboardingInfoResponse> => {
      const params = new URLSearchParams({
        personIdentifier: personIdentifier!,
        practiceIdentifier,
      })

      return read<OnboardingInfoResponse>(`info?${params}`)
    },
  })
}

export { useOnboardingInfo }
